import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Button from '../../elementals/button';
import Modal from '../modal';
import VerticalExpander from '../../elementals/verticalExpander';
import Animate from '../../elementals/animate';
const DURATION_MS = 300;
export const DefaultFooter = ({ onClose, isNextStepEnabled = () => true, setStep, step, maxSteps, }) => (_jsxs("div", { style: {
        width: '100%',
        display: 'inline-flex',
        justifyContent: 'flex-end',
        gap: '12px',
    }, children: [_jsx(Button, { disabled: step < 1, role: 'secondary', elmId: 'back_button', onClick: () => {
                setStep(step - 1);
            }, children: "Back" }), step === maxSteps - 1 ? (_jsx(Button, { disabled: !isNextStepEnabled(step), className: 'done-button', role: 'primary', elmId: 'done_button', onClick: onClose, children: "Done" })) : (_jsx(Button, { disabled: !isNextStepEnabled(step), role: 'primary', elmId: 'next_button', onClick: () => {
                setStep(step + 1);
            }, children: "Next" }))] }));
const MultiStepModal = ({ trigger, onClose, isOpen, title, fullScreen, size, steps, isNextStepEnabled = () => true, customFooter, }) => {
    const [step, setStep] = useState(0);
    const [maxSteps, setMaxSteps] = useState(steps.length);
    const [stepDelayed, setStepDelayed] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const customFooterElement = customFooter
        ? React.createElement(customFooter, {
            onClose,
            setStep,
            step,
            maxSteps,
            isNextStepEnabled,
        })
        : null;
    useEffect(() => {
        setMaxSteps(steps.length);
    }, [steps]);
    useEffect(() => {
        if (isOpen) {
            setStep(0);
        }
    }, [isOpen]);
    useEffect(() => {
        setIsVisible(false);
        setTimeout(() => {
            setStepDelayed(step);
            setIsVisible(true);
        }, DURATION_MS);
    }, [step]);
    return (_jsxs(Modal, { title: steps[step].title || title, trigger: trigger, fullScreen: fullScreen, open: isOpen, onClose: onClose, size: size, children: [_jsx(Modal.Content, { children: _jsx(VerticalExpander, { children: _jsx(Animate.FadeInOut, { isVisible: isVisible, duration: DURATION_MS, children: steps[stepDelayed].content }) }) }), _jsx(Modal.Actions, { children: customFooterElement || (_jsx(DefaultFooter, { onClose: onClose, setStep: setStep, step: step, maxSteps: maxSteps, isNextStepEnabled: isNextStepEnabled })) })] }));
};
export default MultiStepModal;
//# sourceMappingURL=index.js.map